




















































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import TaskPo from "@/store/entities/scheduledtasks/taskpo";
import TreeSelect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import Util from "@/lib/util";

@Component({
    components: { TreeSelect },
})
export default class EditTask extends AbpBase {
    @Prop({ type: Boolean, default: false }) value: boolean;
    taskPo: TaskPo = new TaskPo();
    loading: boolean = false;
    cronModalShow: boolean = false;
    changeCron() {
        this.cronModalShow = !this.cronModalShow;
        console.log(this.cronModalShow);
    }
    created() {
        this.getcompanytree();
        this.taskPo.status = 0;
    }
    /**获取公司树 */
    async getcompanytree() {
        await this.$store
            .dispatch("organization/getCommanySelectTree")
            .then((val) => {
                this.$data.companytree = val;
            })
            .catch((err) => {
                //return null;
            });
    }
    /**保存 */
    save() {
        (this.$refs.itemModelForm as any).validate(async (valid: boolean) => {
            if (valid) {
                this.loading = true;
                await this.$store.dispatch({
                    type: "tasklist/update",
                    data: this.taskPo,
                }).catch((err) => {
                    console.log(err);
                    this.loading = false;
                });
                this.loading = false;
                (this.$refs.itemModelForm as any).resetFields();
                this.$emit("save-success");
                this.$emit("input", false);
            }
        });
    }
    cancel() {
        (this.$refs.itemModelForm as any).resetFields();

        this.$emit("input", false);
    }
    visibleChange(value: boolean) {
        if (!value) {
            this.$emit("input", value);
        } else {
            this.taskPo = Util.extend(true, {}, this.$store.state.tasklist.editTask);
        }
    }
    modelRule = {
        organizationId: [
            {
                required: true,
                type: "number",
                message: this.L("CanNotBeEmpty"),
                trigger: "blur",
            },
        ],
        taskName: [
            {
                required: true,
                message: this.L("CanNotBeEmpty"),
                trigger: "blur",
            },
        ],
        assemblyName: [
            {
                required: true,
                message: this.L("CanNotBeEmpty"),
                trigger: "blur",
            },
        ],
        className: [
            {
                required: true,
                message: this.L("CanNotBeEmpty"),
                trigger: "blur",
            },
        ],
        cronExpressionString: [
            {
                required: true,
                message: this.L("CanNotBeEmpty"),
                trigger: "blur",
            },
        ],
    };
    data() {
        return {
            companytree: [],
            normalizer(node) {
                if (node.children && !node.children.length) {
                    delete node.children;
                }
                return {
                    id: node.id,
                    label: node.label,
                    children: node.children,
                };
            },
        };
    }
}
